import api from '../../../services/api';

/**
 * API client for live editing presence (`/api/presence`).
 *
 * `ORDER` scope keys on an orderId (editing an existing order); `CUSTOMER_CREATE`
 * keys on a customerId (drafting a new order for that customer). The heartbeat
 * both records the caller as active and returns who else is.
 */
export type PresenceScopeType = 'ORDER' | 'CUSTOMER_CREATE';

export interface PresenceUser {
  userId: string;
  userName: string;
  lastSeenAt: string;
}

/** Record that I'm active on this scope; returns the OTHER active users. */
export async function sendPresenceHeartbeat(
  scopeType: PresenceScopeType,
  scopeKey: string
): Promise<PresenceUser[]> {
  const response = await api.post('/presence/heartbeat', { scopeType, scopeKey });
  return response.data?.others || [];
}

/** Best-effort leave so others stop seeing me promptly (else I expire on my own). */
export async function leavePresence(
  scopeType: PresenceScopeType,
  scopeKey: string
): Promise<void> {
  await api.delete('/presence', { data: { scopeType, scopeKey } });
}
